ready(function () {
	// -- https://codepen.io/GreenSock/pen/KKpLdWW --
	// Effet recherche : les panels se superposent tant qu'ils se suivent.
	// Des qu'un bloc normal arrive (CTA, footer, etc.), la pile s'arrete
	// et le scroll naturel reprend.

	let panelTriggers = [];
	let panelRefreshFrame = null;

	// Le .panel est generalement dans un wrapper .blocks.
	// On travaille au niveau de ce wrapper pour savoir quel bloc vient ensuite.
	const getPanelBlock = function(panel) {
		return panel.closest(".blocks") || panel;
	};

	// Retourne le prochain bloc de contenu utile, en ignorant les wrappers
	// techniques qui ne sont ni des .blocks ni des .panel.
	const getNextScrollBlock = function(panel) {
		const panelBlock = getPanelBlock(panel);
		let nextBlock = panelBlock.nextElementSibling;

		while (nextBlock && !nextBlock.matches(".blocks, .panel")) {
			nextBlock = nextBlock.nextElementSibling;
		}

		return nextBlock;
	};

	// Un panel ne doit etre pinne que si le bloc suivant participe aussi
	// a la serie de panels. Sinon, il se prolongerait sous un bloc normal.
	const isFollowedByPanel = function(panel) {
		const nextBlock = getNextScrollBlock(panel);

		return !!nextBlock && (nextBlock.matches(".panel") || !!nextBlock.querySelector(".panel"));
	};

	// Les panels plus hauts que la fenetre scrollent naturellement.
	// Les pinner fausse la duree du scroll et peut masquer le fond du bloc suivant.
	const isPinnablePanel = function(panel) {
		return panel.offsetHeight <= window.innerHeight + 1;
	};

	// Quand GSAP pinne un panel, il devient fixed.
	// Ce z-index bas garde les panels sous le menu sticky, mais permet au panel
	// suivant de repeindre correctement son background par-dessus le precedent.
	const preparePanelStack = function(panels) {
		panels.forEach(panel => {
			if (window.getComputedStyle(panel).position == "static") {
				panel.style.position = "relative";
			}

			panel.style.zIndex = 1;
		});
	};

	const animatePanel = function() {
		if (typeof(gsap) == 'undefined' || typeof(ScrollTrigger) == 'undefined') {
			return;
		}

		// Reinitialisation propre : utile au resize et apres un swap htmx,
		// sinon plusieurs ScrollTriggers peuvent se cumuler sur les memes panels.
		panelTriggers.forEach(trigger => trigger.kill(true));
		panelTriggers = [];

		const panels = gsap.utils.toArray(".panel");
		preparePanelStack(panels);

		panels.forEach((panel, i) => {
			if (!isFollowedByPanel(panel) || !isPinnablePanel(panel)) {
				return;
			}

			const trigger = ScrollTrigger.create({
				trigger: panel,
				start: "top top",
				pin: true, 
				pinSpacing: false
			});

			panelTriggers.push(trigger);
		});

		ScrollTrigger.refresh();
	}

	// On groupe les recalculs dans une animation frame pour eviter de relancer
	// toute la logique trop souvent pendant un resize ou un swap de contenu.
	const queueAnimatePanel = function() {
		window.cancelAnimationFrame(panelRefreshFrame);
		panelRefreshFrame = window.requestAnimationFrame(animatePanel);
	};

	// -- init on first load --
	animatePanel();
	window.addEventListener("load", queueAnimatePanel, { once: true });
	window.addEventListener("resize", queueAnimatePanel);
	window.addEventListener("orientationchange", queueAnimatePanel);

	// -- reload after swap --
	if (typeof(htmx) != 'undefined' && htmx != null) {
		htmx.on('htmx:afterSwap', function(event) {
			queueAnimatePanel();
		});
	}

});
